import {actions_types} from "../../constants/actions";
import {triggers_type} from "../../constants/triggers";
// Regras de nome e de referência de etapa moram em stepReferences.js, sem
// import da árvore de componentes — reexportadas aqui para quem já as importa
// deste módulo.
import {buildStepReference, normalizeStepName} from "./stepReferences";

export {
    buildStepReference,
    findStepsReferencingPosition,
    normalizeStepName,
    REMOVED_STEP_REFERENCE,
    retargetPositionalReferencesAfterRemoval,
    retargetStepNameInValue,
    retargetStepNameToPosition,
    sanitizeStepNameInput,
    validateStepName,
} from "./stepReferences";

export const getNameFromAction = (action) => {
    return action.name &&  action.name.length > 0  ? action.name : action.defaultName
}

export const getNameFromActionByType = (type) => {
    const action = actions_types.find(item => item.type === type);
    if (action) {
        return action.defaultName;
    }else{
        return type;
    }
}

export const getNameFromTriggerByType = (type) => {
    const trigger = triggers_type.find(item => item.type === type);
    if (trigger) {
        return trigger.name;
    }else{
        return type;
    }
}

/**
 * Rotas que um passo na posição `uptoIndex` pode assumir, como caminhos
 * completos — um desvio dentro de uma rota prefixa as suas ("retirada" + "ia"
 * → "retirada.ia").
 *
 * Declaram rotas os desvios (`switch`), uma por caminho, e as junções
 * (`merge`), a rota única em que os caminhos unidos passam a seguir — para
 * quem escolhe o caminho de um passo, as duas são a mesma coisa.
 */
export const getAvailableBranches = (actions, uptoIndex) => {
    const branches = [];
    for (let i = 0; i < uptoIndex; i++) {
        const action = actions[i];
        if (!action) continue;
        const prefix = action.branch ? `${action.branch}.` : '';

        if (action.type === 'switch') {
            const routes = (action.config && Array.isArray(action.config.routes))
                ? action.config.routes
                : [];
            routes.forEach((route) => {
                if (route && route.name) {
                    branches.push({
                        value: prefix + route.name,
                        label: route.label || route.name,
                        switchName: getNameFromAction(action),
                    });
                }
            });
        }

        if (action.type === 'merge' && action.config && action.config.name) {
            branches.push({
                value: prefix + action.config.name,
                label: action.config.label || action.config.name,
                switchName: getNameFromAction(action),
            });
        }
    }
    return branches;
};

/** Rótulo curto de uma rota (último segmento), para exibição na timeline. */
export const getBranchLabel = (actions, branch) => {
    if (!branch) return null;
    const found = getAvailableBranches(actions, actions.length)
        .find((item) => item.value === branch);
    return found ? found.label : branch.split('.').pop();
};

/**
 * Referência ao resultado de uma etapa, a partir do seu índice na lista
 * (base 0; -1 é o gatilho). Etapa com nome próprio é referenciada pelo nome —
 * assim inserir ou remover etapas antes dela não invalida a referência. Sem
 * nome, sobra a posição: o executor publica em `steps[N]`, com N em base 1.
 */
export const getNameToSnippets = (index, action = null, js = false) => {
    if(index === -1){
        return "trigger";
    }
    const customName = normalizeStepName(action?.name);
    if(!customName){
        if(js){
            return `steps['${index + 1}']`
        }
        return `steps.${index + 1}`
    }
    return buildStepReference(customName, js);
}
